@use '../styles/tokens' as *;

.wrap {
  position: relative;
}

.navBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
}
.navIcon {
  width: 20px;
  height: 20px;
}

.panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 10;
  min-width: 230px;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: $white;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(28, 28, 28, 0.3);
}

.option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 4px;
  background: none;
  text-align: left;
  @include text-13;
  color: $black;

  &:hover {
    background: $blue-gray-9;
  }
}

.checkSlot {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 16px;
}
.checkIcon {
  width: 14px;
  height: 14px;
  color: $utility-blue;
}
